import type { ReactNode } from 'react';
import styles from './CommitReview.module.css';

// One row of the review: a mark in the gutter (✓ filled, ○ needed, · a fact),
// the label, and the value or its editor. The mark is the readiness signal —
// the review is done when no dashed circle is left.

export type ReviewRowState = 'ok' | 'need' | 'info';

export function ReviewRow({ state, label, children }: { state: ReviewRowState; label: string; children: ReactNode }) {
  return (
    <div className={`${styles.row} ${styles[state]}`} data-state={state}>
      <span className={styles.mark} aria-hidden>{state === 'ok' ? '✓' : ''}</span>
      <span className={styles.label}>{label}</span>
      <div className={styles.value}>{children}</div>
    </div>
  );
}
